import { handleInboundMessageEvent } from "./registerEventHandler";
import { isTargetOriginReceived } from "./configuration";
import { pushToInboundMessageBuffer } from "./messageBuffer";

export const createMessageListener = (): void =>
{
    window.addEventListener("message", (event: MessageEvent) =>
    {
        if (!isTargetOriginReceived()) {
            pushToInboundMessageBuffer(event, handleInboundMessageEvent);
        } else {
            handleInboundMessageEvent(event);
        }
    });
};